import { Component, Input, OnChanges } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { getPositiveNumber } from '@cakeiteasy/web-utils';

import { shouldShowStockLimitInfo } from '../../../shared/helpers/product-quantity-info.helper';

@Component({
  standalone: false,
  selector: 'upsell-min-quantity',
  templateUrl: './upsell-min-quantity.component.html',
  styleUrls: ['./upsell-min-quantity.component.scss']
})
export class UpsellMinQuantityComponent implements OnChanges {
  @Input() minQuantity: number;
  @Input() maxQuantity: number;
  @Input() stockLeft: number;
  @Input() dailyLimit: number;
  @Input() count: number;
  @Input() unitKey: string;

  public maxQuantityNotice: string;
  public isStockVisible: boolean;
  public isDailyLimitVisible: boolean;

  constructor(private _translate: TranslateService) {
  }

  ngOnChanges() {
    const maxQuantity = getPositiveNumber(this.maxQuantity);

    this.isStockVisible = shouldShowStockLimitInfo(this.stockLeft, maxQuantity);
    this.isDailyLimitVisible = shouldShowStockLimitInfo(this.dailyLimit, maxQuantity);
    const isMaxVisible = maxQuantity !== null && !this.isStockVisible && !this.isDailyLimitVisible;

    this.maxQuantityNotice = isMaxVisible ? this.getMaxQuantityNotice(maxQuantity) : '';
  }

  private getMaxQuantityNotice(maxQuantity: number): string {
    const unitKey = this._translate.instant(`cakeBuilder.sizeUnits.unitTypePlural.${this.unitKey || 'PER_UNIT'}`);

    return this._translate.instant('cakeBuilder.maxQuantityNotice', { max: maxQuantity, unitKey });
  }
}
